export class SESSION_STORAGE {
  public static USER = btoa('PhDsoft:USER');
  public static FULL_NAME = btoa('PhDsoft:FULL_NAME');
  public static CUSTOMER_ID = btoa('PhDsoft:CUSTOMER_ID');
  public static LOGIN_PARAMETERS = btoa('PhDsoft:LOGIN_PARAMETERS');
  public static OFFLINE_LOGIN = btoa('PhDsoft:LOGIN_SAVED');
  public static TOKEN = btoa('PhDsoft:TOKEN');
  public static CURRENT_ASSET = btoa('PhDsoft:CURRENT_ASSET');
  public static CURRENT_ASSET_ID = btoa('PhDsoft:CURRENT_ASSET_ID');
  public static DOCUMENTS_ACTIVE = btoa('PhDsoft:DOCUMENTS_ACTIVE');
  public static USER_ASSETS = btoa('PhDsoft:USER_ASSETS');
}
